import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaGamepad } from 'react-icons/fa';
import { getTvRemotePath } from '../services/capability';

// One entry-point button for TV pairing:
//   narrow/mobile -> /remote  (phone remote)
//   wide/TV/laptop  -> /tv     (TV pairing page)

const TVRemoteButton = ({ variant = 'desktop', onNavigate }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const target = getTvRemotePath();
  const active = location.pathname === '/remote' || location.pathname === '/tv';

  const onClick = () => {
    navigate(target);
    if (typeof onNavigate === 'function') onNavigate();
  };

  if (variant === 'mobile') {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label="TV Remote"
        aria-pressed={active}
        className={`flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-lg transition-colors ${
          active ? 'text-accent-gold' : 'text-gray-400 hover:text-white'
        }`}
      >
        <FaGamepad className="w-5 h-5" />
        <span className="text-[10px] font-semibold leading-none">TV Remote</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`px-4 py-2 text-sm font-medium transition-all rounded-lg ${
        active
          ? 'text-accent-gold bg-accent-gold/10 font-semibold'
          : 'text-gray-300 hover:text-white hover:bg-white/5'
      }`}
    >
      TV Remote
    </button>
  );
};

export default TVRemoteButton;
